<template>
  <b-container fluid id="results">

    <!-- LITTLE TITLES ON TOP -->
    <b-row class="space-t2 space-b2">
      <b-col cols="6"><p class="sans-s">Title</p></b-col>
      <b-col cols=""><p class="sans-s">Typ</p></b-col>
      <b-col cols=""><p class="sans-s">Eintragsverantwortung</p></b-col>
      <!-- <b-col cols=""><p class="sans-s">Subproject</p></b-col> -->
    </b-row>

    <!-- CONTENT -->
    <router-link :to="'/entry/' + entry.slug" v-for="(entry, k) in filteredPosts" :key="'post-' + k">
      <b-row class="result space-t2 space-b2">    
        <b-col cols="6"><p>{{ entry.title}}</p></b-col>
        <b-col cols=""><p>{{ entry.typ|capitalize }}</p></b-col>
        <b-col cols="">
          <span v-for="(item, i) in entry.responsible" :key="'responsible-' + i" class="responsible">{{ item.fullName }}</span>
        </b-col>
        <!-- <b-col cols=""><span v-for="(item, j) in entry.subproject" :key="'subproject-' + j">{{ item|capitalize }}</span></b-col> -->
      </b-row>
    </router-link>  
    
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Results",
  computed: {
    // get the filteredPosts from the Store
    ...mapGetters(["filteredPosts"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/master.scss";

.row {
  border-bottom: 0.1rem solid black;
}
.row.result {
  border-bottom: 0.1rem solid black;
  cursor: pointer;
  transition: 0.3s;
  & span {
    padding-right: 0.8rem;
  }
  &:hover {
    transition: 0.3s;
    background-color: #1d1d1d;
    & p,
    & span,
    & a {
      transition: 0.3s;
      color: white;
    }
  }
}
.responsible:after {
  content: ',';
}
.responsible:last-of-type:after {
  content: none;
}
</style>